<script>
    import { fade } from 'svelte/transition';
    import { createEventDispatcher, onMount } from 'svelte';

    import videoPoster3D from '@src/assets/video/video_poster_3d.mp4';
    import videoPosterNormal from '@src/assets/video/video_poster.mp4';

    const dispatch = createEventDispatcher();

    export let isMainVideoPlaying;
    export let videoPosterType;

    let videoPoster;
    let videoPosterSrc;

    const getVideoPoster = videoType => {
        if (videoType === '3d') return videoPoster3D;
        return videoPosterNormal;
    };

    // Initialize videoPosterSrc only if videoPosterType
    $: if (videoPosterType !== undefined) {
        videoPosterSrc = getVideoPoster(videoPosterType);
    }

    $: bgOpacity = isMainVideoPlaying ? '0.7' : '1';

    onMount(() => {
        dispatch('init', videoPoster);

        window.addEventListener('click', () => {
            if (videoPoster) videoPoster.play();
        });
    });

    $: {
        if (videoPoster && videoPosterType !== undefined) {
            if (isMainVideoPlaying) {
                videoPoster.pause();
                videoPoster.currentTime = 0;
            } else {
                videoPoster.play();
            }
        }
    }
</script>

{#if videoPosterType !== undefined}
    <video
        playsinline
        muted
        autoplay
        loop
        class="video-poster transition-all duration-500"
        bind:this={videoPoster}
        in:fade|global
        out:fade|global
        style:opacity={bgOpacity}
    >
        <source src={videoPosterSrc} type="video/mp4" />
    </video>
{/if}

<style>
    .video-poster {
        transition: opacity 0.5s;
    }
</style>
